import React, {
  PropsWithChildren,
  TableHTMLAttributes,
  HTMLAttributes,
  ThHTMLAttributes,
  TdHTMLAttributes,
} from 'react';

const Table: React.FC<PropsWithChildren<TableHTMLAttributes<HTMLTableElement>>> = ({
  children,
  className,
  ...props
}) => (
  <table
    className={`min-w-full divide-y divide-kala-700 ${className || ''}`}
    {...props}
  >
    {children}
  </table>
);

const TableHeader: React.FC<
  PropsWithChildren<HTMLAttributes<HTMLTableSectionElement>>
> = ({ children, className, ...props }) => (
  <thead className={`bg-kala-900/50 ${className || ''}`} {...props}>
    {children}
  </thead>
);

const TableBody: React.FC<
  PropsWithChildren<HTMLAttributes<HTMLTableSectionElement>>
> = ({ children, className, ...props }) => (
  <tbody
    className={`bg-kala-800 divide-y divide-kala-700 ${className || ''}`}
    {...props}
  >
    {children}
  </tbody>
);

const TableRow: React.FC<
  PropsWithChildren<HTMLAttributes<HTMLTableRowElement>>
> = ({ children, className, ...props }) => (
  <tr className={className} {...props}>
    {children}
  </tr>
);

const TableHead: React.FC<
  PropsWithChildren<ThHTMLAttributes<HTMLTableCellElement>>
> = ({ children, className, ...props }) => (
  <th
    className={`px-6 py-3 text-left text-xs font-medium text-kala-300 uppercase tracking-wider ${className || ''
      }`}
    {...props}
  >
    {children}
  </th>
);

const TableCell: React.FC<
  PropsWithChildren<TdHTMLAttributes<HTMLTableCellElement>>
> = ({ children, className, ...props }) => (
  <td
    className={`px-6 py-4 whitespace-nowrap text-sm text-kala-300 ${className || ''
      }`}
    {...props}
  >
    {children}
  </td>
);

const TableCaption: React.FC<
  PropsWithChildren<HTMLAttributes<HTMLTableCaptionElement>>
> = ({ children, className, ...props }) => (
  <caption
    className={`px-6 py-4 whitespace-nowrap text-sm text-kala-500 ${className || ''
      }`}
    {...props}
  >
    {children}
  </caption>
);

export {
  Table,
  TableHeader,
  TableBody,
  TableRow,
  TableHead,
  TableCell,
  TableCaption,
};
